<template>
  <v-container fluid grid-list-sm>
    <v-layout class="d-flex justify-center">
      <v-flex md6 sm8>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Todas mis solicitudes</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <div style="height: 200px;" v-if="progress">
              <p>{{ message }}</p>
              <v-progress-linear
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </div>
            <v-list two-line v-else>
              <template v-for="item in documentos">
                <v-list-tile
                  :key="item.id"
                  v-if="item.pagada"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{item.periodo.identificacionCorta}} - {{ item.documento.clave }} - {{ item.documento.descripcion }}</v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary"><strong>Estatus:</strong> {{ getStatus(item) }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  :key="item.id"
                  v-else
                  @click="download(item)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{item.periodo.identificacionCorta}} - {{ item.documento.clave }} - {{ item.documento.descripcion }}</v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary"><strong>Estatus:</strong> {{ getStatus(item) }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-icon
                      color="teal"
                    >
                      cloud_download
                    </v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import fileSaver from 'file-saver'

  export default {
    name: 'ConsultarPage',
    data: () => ({
      documentos: [],
      progress: false,
      message: ''
    }),
    mounted () {
      this.getDocumentos()
    },
    methods: {
      getDocumentos () {
        this.message = 'Cargando las solicitudes'
        this.progress = true
        axios.get('/doctos-oficiales/solicitudes')
          .then(response => {
            this.progress = false
            this.documentos = response.data.data
          })
      },
      download (item) {
        this.progress = true
        this.message = 'Generando el documento'
        axios.get('/doctos-oficiales/download/' + item.id, { responseType: 'arraybuffer' })
          .then(response => {
            this.progress = false
            const blob = new Blob([response.data], { type: response.headers['content-type'] })
            fileSaver.saveAs(blob, 'solicitud.pdf')
          })
      },
      getStatus (item) {
        if (item.pagada && item.generada && item.entregada) {
          return 'Entregada - ' + item.fechaEntregada
        }

        if (item.pagada && item.generada && !item.entregada) {
          return 'Generada - ' + item.fechaGenerada
        }

        if (item.pagada && !item.generada && !item.entregada) {
          return 'Pagada'
        }

        return 'Pago pendiente'
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/doctos-oficiales/ConsultarPage.vue